import {api, apiAbs} from 'portal-core/api';
import _ from 'lodash';
import {pathLastSegment, pathSecondLastSegnment} from '../utils/stringUtils';
import {env} from '../env';
import {traverseObject} from '../utils/objectUtils';
import {dateToString, today} from '../utils/dateUtils';
import {navigateWithData } from '../navigation/navigationHistory';
import insuredNew from '../../../app/config/insured-new.json5';
import {GA_CONFIGURATION, GA_PRODUCT_CODE_KEY,GA_PRODUCT_VERSION_KEY, sendGoogleAnalyticsEvent} from "../utils/googleAnalyticsUtils";

export function getProviderCode(carrierGroupId, postalCode, licenseClass, customerRef, effectiveDate) {
  const limitCnt = env.producerCodeLimit ? env.producerCodeLimit : '20';
  return api.get(`/providers?providerTypeCd=Producer&limit=${limitCnt}&providerNumber=${env.producerCode}`).then(TO_DATA).then(producers => {
    if (!producers) throw 'Services unavailable';
    const provider = producers.providerListItems.find(p => p.providerMini.providerNumber === env.producerCode);
    if (!provider) {
      throw `provider ${env.producerCode} doesn't exist`;
    }
    return postApplication(carrierGroupId, postalCode, licenseClass, provider, customerRef, effectiveDate)

  });
}

export function postApplication(carrierGroupId, postalCode, licenseClass, provider, customerRef, effectiveDate) {

  return api.get(`/products?carrierGroupId=${carrierGroupId}&postalCode=${postalCode}&licenseClass=${licenseClass}`).then(TO_DATA).then(producers => {
    if (Object.entries(producers).length === 0 && producers.constructor === Object) {
      return
    }
    const effectiveDt = effectiveDate ? effectiveDate : dateToString(today());
    const typeOfPolicy = producers.productListItems[0].quickQuoteEnabledInd ? 'QuickQuote' : 'Quote';
    let applicationObj = {
      typeCd: typeOfPolicy,
      customerRef: customerRef,
      basicPolicy: {
        businessSourceCd: 'DirectPortal',
        productVersionIdRef: producers.productListItems[0].productVersionId,
        providerRef: provider.providerMini.systemId,
        effectiveDt: effectiveDt
      },
    };
    localStorage.setItem(GA_PRODUCT_CODE_KEY,licenseClass);
    localStorage.setItem(GA_PRODUCT_VERSION_KEY,producers.productListItems[0].productVersionId);
    sendGoogleAnalyticsEvent(GA_CONFIGURATION.Quote_Started,true);
    // applicationObj.insured = Object.assign(insuredObj);
    applicationObj.insured = Object.assign(insuredNew);

    return api.post('/applications', applicationObj)
  })
}

export function startApplication({carrierGroupId, postalCode, licenseClass, customerRef, effectiveDate}) {
  return getProviderCode(carrierGroupId, postalCode, licenseClass, customerRef, effectiveDate)
      .then(response => systemIdFromLocation(response.headers.location));
}

function systemIdFromLocation(location) {
  return pathLastSegment(location);
}

function resourceDetailsFromLocation(location) {
  const resource = pathSecondLastSegnment(location);
  const id = pathLastSegment(location);
  return {resource, id};
}

export function getApplication(systemId) {
  return api.get('/applications/' + systemId + '/full').then(TO_DATA);
}

const TO_DATA = r => (r ? r.data : null);


export function getUWData(applicationSystemId) {
  return getApplication(applicationSystemId).then(application => {
    const links = _.keyBy(application._links, 'rel');
    // axios.all([
    return Promise.all([

      apiAbs.get(links.productSetupFull.href).then(TO_DATA),
      apiAbs.get(links.systemCodeRefs.href).then(TO_DATA)

    ]).then(([productSetup, codeRefs]) => {
      const productId = application.basicPolicy.productVersionIdRef;

      return {
        application,
        productInfo: {
          productId,
          productSetup,
          codeRefs,
        }
      }
    });

  });
}

export const putApplication = application => new Promise((resolve, reject) => api
    .put('/applications/' + application.systemId + '/full', removeTempFields(application))
    .then(request => resolve(TO_DATA(request)))
    .catch(reject));


export function convertToQuote(systemId, typeCd) {
  if (typeCd === "QuickQuote") {
    return api.post(`/applications/${systemId}/convertToQuoteRequest`)
        .then(response => systemIdFromLocation(response.headers.location));
  } else if (typeCd === "Quote") {
    return api.post(`/applications/${systemId}/bindRequest`)
        .then(response => systemIdFromLocation(response.headers.location));
  }
}

export const retrieveQuote = async (request) => {
  // Return the systemId for the quote/application number (eg: QT-0000XXXX)
  const {postalCode, phoneNumber, birthDate, emailAddress, quoteOrAppNumber} = request;
  return await api.put(
      '/applications/updateSessionLinkRequest',
      {postalCode, phoneNumber, birthDate, emailAddress},
      { params: {quoteOrAppNumber} }
  ).then(response => systemIdFromLocation(response.headers.location));
}

export function retrieveQuoteFromToken(request) {
  // Return the systemId for the quote/application token (from /clients/XXX/portalLinkRequest)
  const {resourceToken, clientId} = request;
  return (api.get(`/clients/${clientId}/resourceLink?token=${resourceToken}`)
      .then(response => systemIdFromLocation(response.headers.location)));
}

export function retrieveResourceFromToken(request) {
  // Return the systemId for the quote/application token (from /clients/XXX/portalLinkRequest)
  const {resourceToken, clientId} = request;
  return (api.get(`/clients/${clientId}/resourceLink?token=${resourceToken}`)
      .then(response => resourceDetailsFromLocation(response.headers.location)));
}

function removeTempFields(app) {
  traverseObject(app, bean => {
    if (bean._tempId) {
      delete bean._tempId;
    }
  });
  return app;
}

export const onSubmitAgent = async (resourceId, applicationNumber) => {
  try {
    sendGoogleAnalyticsEvent({...GA_CONFIGURATION.Refer_To_Agent,event_path_from:window.location.pathname});
    const agentResponse = await api.post(
        `/applications/${resourceId}/consumerAgentRequest`
    );
    if (agentResponse.status === 200 || agentResponse.status === 201) {
      navigateWithData('/agent-success', applicationNumber)
    } else if (agentResponse.status === 'error') {
      throw new Error('Agent response returned error');
    }
  } catch (err) {
    navigateWithData('/agent-error', applicationNumber)
  }
}

export function getQuestionsForProduct(systemId, applState) {
  const query = (applState ? ('?applicationState=' + applState) : '');
  return api.get('/applications/' + systemId + '/availableQuestions' + query).then(TO_DATA);
}

export function getQuestionsForProductRisk(systemId, lineCd, riskTypeCd, applState) {
  const query = (applState ? ('?applicationState=' + applState) : '');
  return api.get('/applications/' + systemId + '/lines/' + lineCd + '/availableRiskTypes/' + riskTypeCd + '/availableQuestions' + query).then(TO_DATA);
}

export function getQuestionsForDriver(systemId, driverTypeCd, applState) {
  const query = (applState ? ('?applicationState=' + applState) : '');
  return api.get('/applications/' + systemId + '/availableDriverTypes/' + driverTypeCd + '/availableQuestions' + query).then(TO_DATA);
}

export const getRiskCoverages = async (systemId,lineCd,riskNum,incDeleted=false) => {
  return  api.get(`/applications/${systemId}/lines/${lineCd}/risks/${riskNum}/coverages?includeDeleted=${incDeleted}`).then(TO_DATA);
}

export function getPolicyHashForPortal(policyNumber) {
  const request = { id: policyNumber, container: 'Policy' };
  return api.post('/clients/consumersalesportal/portalLinkRequest', request).then(TO_DATA);
}